function getHashQueryString(url) {
  const [, search] = url.split("?");
  if (search) {
    return `?${decodeURIComponent(search)}`;
  }
  return "";
}

function getSearchString(url) {
  const index = url.indexOf('?')
  return url.substr(index)
}

export default function getQueryString(name, queryUrl) {
  let url = queryUrl || window.location.href
  const reg = new RegExp(`(^|&)${  name  }=([^&]*)(&|$)`, "i");
  url = url.includes("#")
    ? getHashQueryString(url)
    : getSearchString(url);
  const r = url.substr(1).match(reg);
  if (r != null) return decodeURIComponent(unescape(r[2]));
  return null;
}